import React from 'react';
import { motion } from 'framer-motion';

import useAnimate from '../ui/Motion';

import Reveal from '../ui/Reveal';
import { pledge } from '../data/site';

const EASE = [0.16, 1, 0.3, 1];

/** The three "We are / We provide / We offer" columns. */
export default function Pledge({ items = pledge, className = '' }) {
    const reduced = !useAnimate();

    return (
        <div className={`pledge ${className}`.trim()}>
            {items.map((col, ci) => (
                <Reveal className="pledge__col" key={col.rest} delay={ci * 0.08} y={26}>
                    <h3 className="pledge__title">
                        <em>{col.lead}</em> {col.rest}
                    </h3>

                    <ul>
                        {col.items.map((entry, i) => (
                            <motion.li
                                key={entry}
                                initial={reduced ? false : { opacity: 0, x: -10 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true, amount: 0.4 }}
                                transition={{ duration: 0.5, delay: 0.04 * i, ease: EASE }}
                            >
                                <span className="pledge__tick" aria-hidden="true" />
                                {entry}
                            </motion.li>
                        ))}
                    </ul>
                </Reveal>
            ))}
        </div>
    );
}
